










import { Vue, Component } from 'vue-property-decorator';
import RecepcionesActividad from '@/pantallas/Recepcion/RecepcionesActividad.vue';
import { fetchProveedoresGps } from '@/reusable/proveedorGps/fetchProveedoresGps';
import { fetchClientesProveedorGps } from '@/reusable/proveedorGps/fetchClientesProveedorGps';

@Component({
  components: { RecepcionesActividad },
})
export default class RecepcionesActividadPantalla extends Vue {
  created() {
    fetchProveedoresGps.cache.clear();
    fetchClientesProveedorGps.cache.clear();
  }
}
